import { render } from "./App.vue?vue&type=template&id=5f1a35ba"
const script = {}

import "./App.vue?vue&type=style&index=0&id=5f1a35ba&lang=scss"

import exportComponent from "D:\\Projects For Fun\\PortfolioWebsite\\portfolio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__